import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useDialog } from "app/providers/dialog";
import Guid from "common/values/guid/guid";
import ViewIndividualProfile from "marketplace/values/individual-profile/view/view-individual-profile";
import UserInfo from "work/values/user-info/user-info";

const StyledLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.common.black,
  cursor: 'pointer',
  display: 'flex',
  overflow: 'hidden',
  textDecoration: 'underline',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

type CreatorLinkProps = {
  creator: UserInfo;
};

export default function CreatorLink(props: Readonly<CreatorLinkProps>) {
  const { creator } = props;

  const { openDialog, closeDialog } = useDialog();

  function openProfileDialog(individualId: Guid) {
    openDialog({
      component: (
        <ViewIndividualProfile 
          individualId={individualId} 
        />
      ),
      contentSxProps: {
        display: "flex",
      },
      MuiProps: {
        fullWidth: true,
        maxWidth: "lg",
      },
      titleStyle: {
        position: "absolute",
        right: 0,
        top: 0,
      },
      onClose: closeDialog,
    });
  }

  return (
    <StyledLink
      onClick={(event) => {
        event.stopPropagation();
        openProfileDialog(creator.individualId);
      }}>
      {`${creator.name.firstName} ${creator.name.lastName}`}
    </StyledLink>
  );
}
